<template>
  <div>

      <!-- Header -->
      <div class="py-3 mb-3 border-bottom">
          <div class="container">
              <div class="row">
                  <div class="col-12 col-sm-6 d-flex">
                      <h5 class="m-0 p-0 align-self-center">
                          <i class="fas fa-tv mr-1"></i> Cursos
                      </h5>
                  </div>
                  <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">
                      <b-button @click="openModalCreate" variant="primary" class="ml-sm-auto mr-auto mr-sm-0 mt-3 mt-sm-0">
                          Criar Curso
                      </b-button>
                  </div>
              </div>
          </div>
      </div>

      <!-- Container -->
      <div class="container mx-auto">
          <b-overlay :show="loading" rounded="sm">
              <div class="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-3">
                <div class="col mb-3" style="max-width: 310px;" v-for="course in courses" :key="course.id">

                    <div class="course-card shadow-sm rounded-lg" role="button" >
                        <div class="course-title p-2 text-white d-flex gap-2 justify-content-between " @click="openModule(course)">
                            <p class="w-fit font-weight-bolder h4 mt-auto mb-0"><span class="shadow-sm">{{course.name}}</span></p>

                        </div>

                        <img :src="course.img_preview_url" class="course-image" alt=""/>

                        <div class="course-info p-2 w-100 d-flex justify-content-between align-items-center gap-2">
                            <div class="badge badge-dark p-1">
                                <span class="">{{course.modules_count}}</span> Módulos
                            </div>
                            <div class="dropdown dropleft">
                                <button class="btn btn-sm btn-dark w-fit p-0" type="button" data-toggle="dropdown" aria-expanded="false" >
                                    <svg xmlns="http://www.w3.org/2000/svg"  height="18px" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                    </svg>
                                </button>

                                <div class="dropdown-menu">
                                    <button class="dropdown-item" @click="openModalEdit(course)">
                                        <div class="d-flex gap-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                            </svg>


                                            Editar curso
                                        </div>
                                    </button>

                                    <button class="dropdown-item" @click="openModalDestroy(course)">
                                        <div class="d-flex gap-2 text-danger">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                            </svg>
                                            Excluir curso
                                        </div>
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>

                    <!--
                        <div class="card mb-3 border shadow" >
                            <div class="card-header py-3">
                                <a :href="'/teacher/courses/' + course.id + '/modules'">
                                    <h5 class="card-title p-0 m-0">
                                        {{ course.name }}
                                    </h5>
                                </a>
                            </div>
                            <div class="card-img border-bottom">
                                <img :src="course.img_preview_url" class="" alt="" style="width: 100%; min-height: 100px; height: 225px;" />
                            </div>
                            <div class="card-body">
                                <div>
                                    <b>{{ course.groups_count }}</b> Turmas
                                </div>
                                <div>
                                    <b>{{ course.modules_count }}</b> Módulos
                                </div>
                            </div>
                            <div class="card-footer py-3 d-flex justify-content-between">
                                <b-button  variant="outline-primary">
                                    <i class="fas fa-edit"></i>
                                </b-button>

                                <b-button  variant="outline-danger">

                                </b-button>
                            </div>
                        </div>
                    -->
                </div>
              </div>

              <div v-if="courses.length === 0" class="text-center py-5 my-4">
                  Não temos cursos disponíveis para você :( Crie um novo curso no botao acima!
              </div>
          </b-overlay>
      </div>

      <!-- Create -->
      <create @created="load" :groups="groups"></create>

      <!-- Edit -->
      <edit @updated="load" :groups="groups"></edit>

      <!-- Delete -->
      <destroy @destroyed="load"></destroy>
  </div>
</template>

<script>
import Create from './Create'
import Edit from './Edit'
import Destroy from './Destroy'

export default {
    props: ['groups'],
    components: {
        Create,
        Edit,
        Destroy
    },
    data() {
        return {
            loading: false,
            courses: [],
        }
    },
    created() {
        this.load();
    },
    methods: {
        load() {
            this.loading = true;
            axios.get('/teacher/courses/all')
                .then(response => {
                    this.courses = response.data.data.courses;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                });
        },

        openModalCreate() {
            this.$root.$emit('open-modal-create');
        },

        openModalEdit(course) {
            this.$root.$emit('open-modal-edit', course);
        },

        openModalDestroy(course) {
            this.$root.$emit('open-modal-destroy', course);
        },

        openModule(course) {
            window.location.href = '/teacher/courses/' + course.id + '/modules';
        }
    },
}
</script>

<style scoped>
    .course-card{
        max-width: 310px;
        height: 430px;
        overflow: hidden;
        position: relative;

    }



    .course-image{
        position: absolute;
        width: auto;
        height: 100%;
        left: 50%;
        transform: translateX(-50%);

    }
    .course-title {
        position: absolute;
        z-index: 998;
        width: 100%;
        height: 100%;
        transition: 2s ease-in-out;
        cursor: pointer;
        background: linear-gradient(0deg, rgba(0,0,0,.8) 0%, rgba(249,249,249,0) 80%);

    }
    .course-title:hover {
        background: linear-gradient(0deg, rgba(0,0,0,.8) 0%, rgba(0,0,0,0.5) 80%);
        transition: 2s ease-in-out;

    }

    .course-info {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
    }

</style>
